export default __webpack_public_path__ + "static/media/combo_ielts_thumb.dd687baa.jpg";